export const GlobalizationButtonDirection = {
	GLOBALIZED_FOR_AND_THROUGH_THE_USER: 'globalizedForAndThroughTheUser',
	GLOBALIZED_FOR_THE_USER: 'globalizedForTheUser',
	GLOBALIZED_THROUGH_THE_USER: 'globalizedThroughTheUser',
	UNINVOLVED: 'uninvolved',
} as const;

export const GLOBALIZATION_BUTTON_DIRECTION_VALUES = Object.values(GlobalizationButtonDirection);

type GlobalizationButtonDirection = (typeof GlobalizationButtonDirection)[keyof typeof GlobalizationButtonDirection];

export const Globalization = {
	GLOBALIZED: 'globalized',
	GLOBALIZED_WITH_MESSAGE: 'globalizedWithMessage',
	NOT_GLOBALIZED: 'notGlobalized',
} as const;

export const GLOBALIZATION_VALUES = Object.values(Globalization);

export type Globalization = (typeof Globalization)[keyof typeof Globalization];
